import { render, staticRenderFns } from "./subMain.vue?vue&type=template&id=6e106de4&scoped=true&"
import script from "./subMain.vue?vue&type=script&lang=js&"
export * from "./subMain.vue?vue&type=script&lang=js&"
import style0 from "./subMain.vue?vue&type=style&index=0&id=6e106de4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e106de4",
  null
  
)

export default component.exports